import { action, computed, makeAutoObservable, observable } from "mobx"


export class QuizStep{
    static BEGIN = 'BEGIN';
    static ISSUES = 'ISSUES';
    static POSITION = 'POSITION';
    static FEATURES = 'FEATURES';
    static RESULT = 'RESULT';
    static toList(){
        return [this.BEGIN, this.ISSUES, this.POSITION, this.FEATURES, this.RESULT]
    }
    static getByIndex(index){
        return this.toList()[index]
    }
    static getIndexByName(name){
        return this.toList().findIndex(el=>el === name)
    }
}


export default class QuizStore{
    @observable isOpen = false
    @observable stepIndex = 0
    @observable stepsData = [
        {
            index: 0,
            id: "user_type",
            title: `Dla kogo jest przeznaczony materac?`,
            subtitle: `(Wybierz jedną opcję)`,
            multiple: false,
            required: true,
            conditions: [],
            options: [
                { value: 'dziecko', text: 'Dziecko', className: 'w-auto w-md-30' },
                { value: 'dorosly', text: 'Dorosły', className: 'w-auto w-md-30' },
                { value: 'senior', text: 'Senior', className: 'w-auto w-md-30' },
                { value: 'para', text: 'Para', className: 'w-auto w-md-30' },
                { value: 'rozne', text: 'Różnie', className: 'w-auto w-md-30' },
            ]
        },
        {
            index: 1,
            id: "child_age",
            title: `Ile lat ma dziecko?`,
            multiple: false,
            required: false,
            conditions: [
                {
                    field: "user_type",
                    value: "dziecko"
                }
            ],
            options: [
                { value: '0-2', text: '0-2 lat', className: 'w-auto w-md-30' },
                { value: '3-5', text: '3-5 lat', className: 'w-auto w-md-30' },
                { value: '6-12', text: '6-12 lat', className: 'w-auto w-md-30' },
                { value: '13-17', text: '13-17 lat', className: 'w-auto w-md-30' },
            ]
        },
        {
            index: 2,
            id: "sleep_position",
            title: `W jakiej pozycji najczęściej zasypiasz?`,
            subtitle: `(Wybierz jedną opcję)`,
            multiple: false,
            required: true,
            conditions: [],
            options:[
                { value: 'side', text: 'Na boku', className: 'w-100 w-md-40' },
                { value: 'back', text: 'Na plecach', className: 'w-100 w-md-40' },
                { value: 'stomach', text: 'Na brzuchu', className: 'w-100 w-md-40' },
                { value: 'varied', text: 'Różnie', className: 'w-100 w-md-40' },
            ]
        },
        {
            index: 3,
            id: "partner_sleep_position",
            title: `W jakiej pozycji śpi Twój partner?`,
            multiple: false,
            required: false,
            conditions: [
                {
                    field: "user_type",
                    value: "para"
                }
            ],
            options:[
                { value: 'side', text: 'Na boku', className: 'w-100 w-md-40' },
                { value: 'back', text: 'Na plecach', className: 'w-100 w-md-40' },
                { value: 'stomach', text: 'Na brzuchu', className: 'w-100 w-md-40' },
                { value: 'varied', text: 'Różnie', className: 'w-100 w-md-40' },
            ]
        },
        {
            index: 4,
            id: "getting_up_problem",
            title: `Czy masz problem z wstaniem z łóżka?`,
            subtitle: `(Wybierz jedną opcję)`,
            multiple: false,
            required: true,
            conditions: [],
            options: [
                { value: 'yes', text: 'Tak', className: 'w-auto w-md-30' },
                { value: 'no', text: 'Nie', className: 'w-auto w-md-30' },
            ]
        },
        {
            index: 5,
            id: "current_issues",
            title: `Jakie wady dostrzegasz w obecnym materacu?`,
            subtitle: `(Możesz zaznaczyć więcej niż jedną odpowiedź)`,
            multiple: true,
            required: true,
            conditions: [],
            options: [
                { value: 'too_hard', text: 'Za twardy' },
                { value: 'too_soft', text: 'Za miękki' },
                { value: 'sagging', text: 'Zapada się' },
                { value: 'transfers_motion', text: 'Przenosi drgania', tooltip: `Tooltip...` },
                { value: 'overheats', text: 'Przegrzewa się' },
                { value: 'other', text: 'Inne' },
            ]
        },
        {
            index: 6,
            id: "desired_features",
            title: `Jakie cechy powinien posiadać nowy materac?`,
            subtitle: `(Możesz zaznaczyć więcej niż jedną odpowiedź)`,
            multiple: true,
            required: true,
            conditions: [],
            options: [
                { value: 'softness', text: 'Miękkość i otulenie' },
                { value: 'temperature_control', text: 'Kontrola temperatury' },
                { value: 'breathability', text: 'Przewiewność' },
                { value: 'back_support', text: 'Podparcie pleców' },
                { value: 'stability', text: 'Stabilność' },
            ]
        },
        {
            index: 7,
            title: `Twoje rekomendowane materace:`,
            multiple: false,
            required: false,
            conditions: [],
            result: true,
            options: []
        }
    ]


    @observable stepValues = observable.map([])
    getStepValue(index, _default = null){
        var value = this.stepValues.get(index);
        if(value){
            return value;
        }
        return _default;
    }
    setStepValue(index, value){
        this.stepValues.set(index, value);
    }

    constructor(){
        makeAutoObservable(this)
        this.data = {}
    }

    getStepValueById(id, _default = null){
        const step = this.stepsData.find(s => s.id === id);
        if (!step) return _default;
        return this.getStepValue(step.index, _default);
    }

    @computed get currentStep(){
        const visibleSteps = this.visibleSteps;
        const data = visibleSteps[this.stepIndex] || {};
        const defaultData = {
            title: '',
            subtitle: '',
            options: [],
            multiple: false,
            required: false,
            conditions: [],
        }
        return {
            ...defaultData,
            ...data,
        }
    }

    @computed get visibleSteps(){
        return this.stepsData.filter((step) => {
            if (step.result) return true;

            if (!step.conditions || step.conditions.length === 0) {
                return true;
            }

            return step.conditions.every(condition => {
                const conditionValue = this.getStepValueById(condition.field);
                return conditionValue === condition.value;
            });
        });
    }

    @computed get currentStepIndex(){
        const step = this.visibleSteps[this.stepIndex];
        return step ? step.index : -1;
    }

    @computed get stepsPayload(){
        const payload = {};
        this.stepsData.forEach(step => {
            if (step.id) {
                payload[step.id] = this.getStepValue(step.index);
            }
        });
        return payload;
    }

    @computed get nextDisabled(){
        const currentStep = this.currentStep;
        const value = this.getStepValue(this.currentStepIndex);
        const isEmptyArray = value instanceof Array && value.length === 0
        const hasValue = value !== undefined && value !== null && !isEmptyArray

        if (currentStep.required && !hasValue) {
            return true
        }

        return this.stepIndex >= this.visibleSteps.length - 1;
    }

 

    @computed get prevDisabled(){
        return this.stepIndex <= 0;
    }

    @action nextStep(){
        if (this.stepIndex < this.visibleSteps.length - 1) {
            this.stepIndex = this.stepIndex + 1;
        }
    }
    @action prevStep(){
        if (this.stepIndex > 0) {
            this.stepIndex = this.stepIndex - 1;
        }
    }

    @action open(){
        this.isOpen = true
    }
    @action close(){
        this.isOpen = false
        this.stepIndex = 0
    }
    @action reset(){
        
        this.stepIndex = 0
        this.stepValues = observable.map([])
    }
}